export function SVGEffects() {
  return (
    <defs id="defs1">
      <defs id="defs1">
        <pattern
          id="pattern3"
          patternTransform="matrix(0.25,0.4330127,-0.4330127,0.25,0,0)"
          x="0"
          y="0"
          preserveAspectRatio="none"
          xlinkHref="#diagonalHatch"
        />
        <pattern
          id="diagonalHatch"
          patternUnits="userSpaceOnUse"
          width="4"
          height="4"
        >
          <path
            d="M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2"
            style={{ stroke: "black", strokeWidth: 1.5 }}
            id="path1"
          />
        </pattern>
        <linearGradient id="linearGradient9">
          <stop
            style={{ stopColor: "#ff0808", stopOpacity: 1 }}
            offset="0"
            id="stop9"
          />
          <stop
            style={{ stopColor: "#d40000", stopOpacity: 0 }}
            offset="1"
            id="stop10"
          />
        </linearGradient>
        <linearGradient id="swatch6">
          <stop
            style={{ stopColor: "#000000", stopOpacity: 1 }}
            offset="0"
            id="stop7"
          />
        </linearGradient>
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath33">
          <rect
            style={{
              fill: "#000000",
              stroke: "none",
              strokeWidth: 0.999995,
              strokeLinecap: "butt",
              strokeLinejoin: "bevel",
              paintOrder: "stroke markers fill",
              stopColor: "#000000",
            }}
            id="rect33"
            width="46.19186"
            height="80.006783"
            x="74.999985"
            y="399.99661"
          />
        </clipPath>
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath24">
          <rect
            style={{
              fill: "none",
              stroke: "#000000",
              strokeWidth: 0.999999,
              strokeLinecap: "butt",
              strokeLinejoin: "bevel",
              paintOrder: "stroke markers fill",
              stopColor: "#000000",
            }}
            id="rect24"
            width="44.999748"
            height="77.937294"
            x="251.53429"
            y="222.73541"
          />
        </clipPath>
        <linearGradient
          id="linearGradient10"
          x1="132.68338"
          y1="951.38556"
          x2="149.04581"
          y2="976.67322"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.48772,18.61945)"
        />
      </defs>
    </defs>
  );
}
